export default {
  data() {
    return {
      views: {
        cart: false,
        checkout: false,
        schedule: false,
        lender: false
      },
      lender: null
    };
  },
  created() {
    this.$bus.$on('cart', this.showCart);
    this.getLender();
  },
  methods: {
    showCart() {
      this.showView('cart');
    },
    async getLender() {
      try {
        const res = await this.$http.post('https://mobile.creditclan.com/api/v3/bnpl/global/settings', {}, {
          headers: { 'x-api-key': 'WE4mwadGYqf0jv1ZkdFv1LNPMpZHuuzoDDiJpQQqaes3PzB7xlYhe8oHbxm6J228' }
        });
        const { lender_id, lender_name, image } = res.data.response.funding_partner;
        this.lender = {
          name: lender_name,
          id: lender_id,
          image
        }
      } catch (e) {
        this.lender = {
          image: "https://www.creditclan.com/images/logo-small.png",
          id: "40245",
          name: "Creditclan",
        }
      }
    },
  },

  computed: {
    schedule() {
      return this.$store.getters['cart/schedule'];
    },
  }
}
